import { TECH_SESSIONS, GET_CONFERENCE_ROOM_LIST, TECH_SESSION_REQUEST,
  SEND_EMAIL_NOTIFICATION, GET_EMAIL_TEMPLATE, CANCEL_TECH_SESSION } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

export const getTechSessionData = (month, year) => {

  let url = TECH_SESSIONS;
  if (month && year) {
    url = `${TECH_SESSIONS}?month=${month}&year=${year}`;
  }
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const addTechSession = (sessionData) => {
  return {
    url: TECH_SESSIONS,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
    payload: sessionData,
  };
};
export const updateTechSession = (sessionID, isInvited, sessionData) => {
  return {
    url: `${TECH_SESSIONS}?sessionID=${sessionID}&isInvited=${isInvited}`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
    payload: sessionData,
  };
};
export const deleteTechSession = (sessionID, isInvited) => {
  return {
    url: `${TECH_SESSIONS}?sessionID=${sessionID}&isInvited=${isInvited}`,
    method: 'delete',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const saveApprovalTechSessionData = (data) => {
  return {
    url: `${TECH_SESSIONS}`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
    payload: data,
  };
};

export const getConferenceRoomList = () => {
  return {
    url: GET_CONFERENCE_ROOM_LIST,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const saveUpdatedTechSessionData = (data) => {
  return {
    url: `${TECH_SESSIONS}`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
    payload: data,
  };
};

export const techSessionRequestApi = (data) => {
  return {
    url: TECH_SESSION_REQUEST,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
    payload: data,
  };
};

export const getEmailTemplate = (type) => {
  return {
    url: `${GET_EMAIL_TEMPLATE}?type=${type}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const sendEmailNotification = (sessionData, isInvited = false) => {
  return {
    url: `${SEND_EMAIL_NOTIFICATION}?isInvited=${isInvited}`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
    payload: sessionData,
  };
};

export const getTechSessionUpdatedDetails = (sessionID) => {
  return {
    url: `${TECH_SESSIONS}?sessionId=${sessionID}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const cancelTechSession = (sessionID, isInvited) => {
  return {
    url: `${CANCEL_TECH_SESSION}?sessionID=${sessionID}&isInvited=${isInvited}`,
    method: 'delete',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const getDepartmentList = (verticalId) => {
  return {
    url: `${TECH_SESSIONS}/${verticalId}`,
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};
